const MenuBurger = ({ className, onClick }) => (
	<svg
		width="32"
		height="33"
		viewBox="0 0 32 33"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		onClick={onClick}
	>
		<path
			className={className}
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.80005 8.4999C4.80005 8.07556 4.96862 7.66859 5.26868 7.36853C5.56874 7.06847 5.9757 6.8999 6.40005 6.8999H25.6C26.0244 6.8999 26.4314 7.06847 26.7314 7.36853C27.0315 7.66859 27.2001 8.07556 27.2001 8.4999C27.2001 8.92425 27.0315 9.33121 26.7314 9.63127C26.4314 9.93133 26.0244 10.0999 25.6 10.0999H6.40005C5.9757 10.0999 5.56874 9.93133 5.26868 9.63127C4.96862 9.33121 4.80005 8.92425 4.80005 8.4999ZM4.80005 16.4999C4.80005 16.0756 4.96862 15.6686 5.26868 15.3685C5.56874 15.0685 5.9757 14.8999 6.40005 14.8999H25.6C26.0244 14.8999 26.4314 15.0685 26.7314 15.3685C27.0315 15.6686 27.2001 16.0756 27.2001 16.4999C27.2001 16.9242 27.0315 17.3312 26.7314 17.6313C26.4314 17.9313 26.0244 18.0999 25.6 18.0999H6.40005C5.9757 18.0999 5.56874 17.9313 5.26868 17.6313C4.96862 17.3312 4.80005 16.9242 4.80005 16.4999ZM4.80005 24.4999C4.80005 24.0756 4.96862 23.6686 5.26868 23.3685C5.56874 23.0685 5.9757 22.8999 6.40005 22.8999H25.6C26.0244 22.8999 26.4314 23.0685 26.7314 23.3685C27.0315 23.6686 27.2001 24.0756 27.2001 24.4999C27.2001 24.9242 27.0315 25.3312 26.7314 25.6313C26.4314 25.9313 26.0244 26.0999 25.6 26.0999H6.40005C5.9757 26.0999 5.56874 25.9313 5.26868 25.6313C4.96862 25.3312 4.80005 24.9242 4.80005 24.4999Z"
			fill="#27272A"
		/>
	</svg>
);

export default MenuBurger;
